import type { TIrrigationZoneEmitter } from 'stores/fieldAssetStore/helperTypes'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const getSavedFlowRate = (
  rate: number,
  unitsPerHour: TIrrigationZoneEmitter['flowRate']['unitsPerHour'],
): TIrrigationZoneEmitter['flowRate'] => ({
  rate,
  unitsPerHour,
  mmPerHour:
    unitConverter
      .irrigationApplicationRate(rate, { inputUnit: unitsPerHour === 'INCH' ? 'in' : 'mm', outputUnit: 'mm' })
      .valueWithNoRounding() ?? rate,
  isDefault: false,
})
